import React from 'react';

import {
  MCText,
  View,
  TextField,
  SelectField,
  ToggleSwitch,
  MCButton,
  CheckboxesField,
  MCError
} from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { remCss, lang, withRouter, objectToSelectList } from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';
import TextareaAutosize from 'react-textarea-autosize';

const Reminder = ({ data, handleData, invalid = {}, num }) => {
  return (
    <View>
      <MCText
        weight={500}
        label={lang.t(LANG_CONST.text.reminder_label, { num }) + ':'}
        style={{ width: remCss(100), marginBottom: remCss(20) }}
      />

      <View style={{ flexDirection: 'row', gap: remCss(20), maxWidth: remCss(900) }}>
        <View style={{ flex: 1 }}>
          <div className='mc-text-field-group template-8'>
            <div className='mc-input-box-cover'>
              <TextareaAutosize
                className='mc-input-box valid'
                placeholder={LANG_CONST.text.type_here}
                value={data.text}
                onChange={(e) => {
                  const value = e.target.value;
                  handleData('text', value);
                }}
                minRows={4}
              />
            </div>
          </div>
          {invalid?.text && <MCError error={invalid.text} />}
        </View>
        <View style={{ width: remCss(150) }}>
          <TextField
            template={8}
            placeholder={LANG_CONST.num}
            name={'timeNumber'}
            value={data.timeNumber}
            type={'number'}
            onChange={handleData}
            invalid={{}}
          />
          {invalid?.timeNumber && (
            <MCError
              error={invalid.timeNumber}
              mcTextProps={{ style: { minWidth: remCss(200) } }}
            />
          )}
        </View>
        <SelectField
          width={remCss(150)}
          template={8}
          name={'timeUnit'}
          options={objectToSelectList(LANG_CONST.constants.reminder_time_unit)}
          value={data.timeUnit}
          onChange={handleData}
          isClearable={false}
        />
        <View style={{ position: 'relative', gap: remCss(10) }}>
          <CheckboxesField
            template={'2'}
            list={objectToSelectList(LANG_CONST.constants.reminder_types)}
            data={data.types}
            onChange={(v) => handleData('types', v)}
          />
          {invalid?.types && (
            <MCError
              error={invalid.types}
              mcTextProps={{ style: { position: 'absolute', bottom: 0, minWidth: remCss(150) } }}
            />
          )}
        </View>
        <View style={{ paddingVertical: remCss(10) }}>
          <ToggleSwitch
            name='active'
            checked={data.active}
            onChange={() => handleData('active', !data.active)}
          />
        </View>
      </View>
    </View>
  );
};
class Notification extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  handleChange = (id) => (n, v) => {
    model.setStateSilent({ change: true });
    model.handleChange(
      'editing',
      model.state.editing.map((item) => {
        if (id === item.id) {
          return { ...item, [n]: v };
        }
        return item;
      })
    );
  };

  render() {
    const { invalid = {}, loading } = model.getApiState('save');
    const reminderInvalid = invalid?.reminders || {};
    return (
      <div className={'mc-container-content mc-all-patients'}>
        <div className={'mc-container-content__header mc-flex-15'}>
          <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.notifications)}</span>
        </div>
        <div className={'mc-container-content__body'}>
          <div
            className={'mc-container-content__body-content mc-bb'}
            style={{ marginTop: remCss(25), zIndex: 0, gap: remCss(30) }}
          >
            {model.state.editing.map((item) => (
              <Reminder
                key={item.id}
                num={item.id}
                data={item}
                handleData={this.handleChange(item.id)}
                invalid={reminderInvalid[item.id]}
              />
            ))}
            <MCText
              textLight
              weight={500}
              lineHeight={30}
              label={[
                `Note:`,
                `  %userFirst% for user first name`,
                `  %user% for user full name`,
                `  %doctorFirst% for doctor first name`,
                `  %doctor% for doctor full name`,
                `  %clinic% for clinic name`
              ].join('\n')}
            />
          </div>
          {model.state.change && (
            <div className={'mc-container-content__body-footer'}>
              <div className={'mc-flex'}>
                <div className={'mc-grow'}></div>
                <MCButton
                  primary
                  light
                  radius
                  medium
                  disabled={loading}
                  onClick={() => {
                    model.setState({
                      change: false,
                      editing: JSON.parse(JSON.stringify(model.state.reminders))
                    });
                  }}
                  label={LANG_CONST.buttons.cancel}
                />
                <MCButton
                  style={{ width: remCss(110) }}
                  primary
                  dark
                  radius
                  medium
                  disabled={loading}
                  loading={loading}
                  onClick={(e) => {
                    e.preventDefault();
                    model.saveData();
                  }}
                  label={LANG_CONST.buttons.save}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(Notification);
